import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import {
  requestProfileStart,
  requestProfileSuccess,
  requestProfileFail,
} from '../actions/profile';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* requestProfile(data) {

  /*console.log('[sages] requestProfile : ', data);*/

  const apiURL = `${url}/api/v1/auth/profile`;

  //====================================================================================================================

  try {
    const data = yield method_GET({ url: apiURL });

    /*console.log("[API] POST : ",);*/

    yield put(requestProfileSuccess(data));

  } catch (error) {
    yield put(requestProfileFail(error));
  }

  //====================================================================================================================

}

export function* watchProfile() {

  /*console.log('[sages] watchProfile : ✅');*/

  yield all([
    takeLatest(requestProfileStart, requestProfile),
  ])
}



